import { TenderOfferParticipant } from 'types';
import { tenderParticipantStatusTypes } from 'utils/tenderOfferTypes';

type GetParticipantStatusProps = {
  participant?: TenderOfferParticipant;
};

type GetParticipantStatusResult = {
  label: string;
  badge: string;
};

export const getParticipantStatus = ({
  participant,
}: GetParticipantStatusProps): GetParticipantStatusResult => {
  const DEFAULT_STATUS = { label: 'Draft', badge: 'badge-gray' };

  if (!participant) return DEFAULT_STATUS;

  const status =
    Object.values(tenderParticipantStatusTypes).find(
      ({ value }) => value === participant.status
    ) ?? tenderParticipantStatusTypes.NOTIFIED;

  return {
    label: status.label,
    badge: status.style,
  };
};
